/**
 * Created by spepa on 10/05/20
 */

const PhotoClover = cc.Sprite.extend({
    ctor: function (cloverData, photos) {
        this._super(bundles.game.frames[`mission_star_gray_${PseudoRandom.GET().random(0, 2)}`]);
        this.photos = photos;
        const images = [photos.imageA, photos.imageB];

        images[(photos.clovers.length + 1) % 2].addChild(this);
        this.setAlignment(cloverData.x * resolutionScale, cloverData.y * resolutionScale);

        const maxSize = cleverapps.styles.PhotoClover.maxSize;
        const baseScale = Math.min(maxSize / this.height, maxSize / this.width);
        this.setScale(baseScale + 0.5 * (Math.random() - 0.5));
        this.baseOpacity = PseudoRandom.GET().random(80, 100);
        this.setOpacity(this.baseOpacity);

        const doppel = this.doppel = new cc.Node();
        doppel.setAnchorPoint(0.5, 0.5);
        doppel.setContentSize2(this.width * this.scale, this.height * this.scale);
        images[photos.clovers.length % 2].addChild(doppel);
        doppel.setAlignment(this.getPosition());

        cleverapps.UI.onClick(this, this.cloverFound.bind(this));
        cleverapps.UI.onClick(doppel, this.cloverFound.bind(this));
    },

    cloverFound: function () {
        if (this.photos.blurred) {
            return;
        }

        if (cleverapps.forces.isRunningForce()) {
            cleverapps.forces.closeRunningForce();
        }
        cleverapps.effects.fire("differences.clover.found");

        const ind = this.photos.clovers.indexOf(this);
        this.photos.clovers.splice(ind, 1);

        const callback = function () {
            cleverapps.eventBus.trigger("collectMark", 1);
        };

        const target = cleverapps.aims.getTarget(`mission_reward${Mission.TYPE_LIGHTNING_RUSH}`);
        const flying = new cleverapps.Spine(bundles.game.jsons.clover_found_json);
        flying.setAnimation(0, "animation", false);
        flying.setAlignment(this.width / 2, this.height / 2);
        this.addChild(flying);
        flying.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(target));

        this.removeFromParent();
        this.doppel.removeFromParent();

        flying.runAction(new cc.Sequence(
            new cc.DelayTime(0.7),
            StandartAnimations.animateCollect(flying, `mission_reward${Mission.TYPE_LIGHTNING_RUSH}`, {
                scale: 1
            }),
            new cc.CallFunc(callback),
            new cc.RemoveSelf()
        ));
    }
});

cleverapps.styles.PhotoClover = {
    maxSize: 60
};